// Market Events Sync Script
// This script ensures events can be loaded from either Firestore or localStorage
document.addEventListener('DOMContentLoaded', function() {
  console.log("Market Events Sync script loaded");
  
  // Initialize Firebase with proper error handling
  initializeFirebase();
  
  // Load events from all possible sources and sync them
  setTimeout(syncEvents, 1000);
});

// Initialize Firebase
function initializeFirebase() {
  if (typeof firebase === 'undefined') {
    console.error('Firebase SDK not loaded');
    return;
  }
  
  try {
    // Check if Firebase is already initialized
    if (!firebase.apps.length) {
      const firebaseConfig = {
        apiKey: "AIzaSyCc9sZL9h8NdRms9F5u-V7EcNCptg-OJDE",
        authDomain: "washnaturals-36b75.firebaseapp.com",
        databaseURL: "https://washnaturals-36b75-default-rtdb.firebaseio.com",
        projectId: "washnaturals-36b75",
        storageBucket: "washnaturals-36b75.firebasestorage.app",
        messagingSenderId: "776912885702",
        appId: "1:776912885702:web:391e3cdf4d6045a3b344c7",
        measurementId: "G-YXKHE3X1LB"
      };
      
      firebase.initializeApp(firebaseConfig);
      console.log("Firebase initialized successfully from sync script");
    } else {
      console.log("Firebase was already initialized");
    }
    
    // Initialize Firestore
    if (!window.db) {
      window.db = firebase.firestore();
      console.log("Firestore initialized in sync script");
    }
  } catch (error) {
    console.error('Error initializing Firebase:', error);
  }
}

// Sync events from multiple sources
async function syncEvents() {
  console.log("Starting event synchronization...");
  
  // Track events from different sources
  let firestoreEvents = [];
  let localEvents = [];
  let sessionEvents = [];
  
  // 1. Try to load from Firestore
  try {
    if (window.db) {
      console.log("Loading events from Firestore...");
      const snapshot = await window.db.collection('events')
        .orderBy('date', 'asc')
        .get();
      
      if (!snapshot.empty) {
        snapshot.forEach(doc => {
          const event = doc.data();
          event.id = doc.id;
          firestoreEvents.push(event);
        });
        console.log(`Loaded ${firestoreEvents.length} events from Firestore`);
      } else {
        console.log("No events found in Firestore");
      }
    }
  } catch (error) {
    console.error("Error loading from Firestore:", error);
  }
  
  // 2. Try to load from localStorage
  try {
    const localData = localStorage.getItem('marketEvents');
    if (localData) {
      localEvents = JSON.parse(localData);
      console.log(`Loaded ${localEvents.length} events from localStorage`);
    }
  } catch (error) {
    console.error("Error loading from localStorage:", error);
  }
  
  // 3. Try to load from sessionStorage
  try {
    const sessionData = sessionStorage.getItem('marketEvents');
    if (sessionData) {
      sessionEvents = JSON.parse(sessionData);
      console.log(`Loaded ${sessionEvents.length} events from sessionStorage`);
    }
  } catch (error) {
    console.error("Error loading from sessionStorage:", error);
  }
  
  // 4. Merge events (prioritize Firestore > localStorage > sessionStorage)
  let mergedEvents = [];
  
  // Helper function to find if an event already exists in the array
  function findEventIndex(array, event) {
    return array.findIndex(e => 
      e.id === event.id || 
      (e.eventName === event.eventName && 
       e.date === event.date && 
       e.location === event.location)
    );
  }
  
  // Add Firestore events first (highest priority)
  if (firestoreEvents.length > 0) {
    mergedEvents = [...firestoreEvents];
  }
  
  // Add localStorage events if they don't already exist
  if (localEvents.length > 0) {
    localEvents.forEach(event => {
      if (findEventIndex(mergedEvents, event) === -1) {
        mergedEvents.push(event);
      }
    });
  }
  
  // Add sessionStorage events if they don't already exist
  if (sessionEvents.length > 0) {
    sessionEvents.forEach(event => {
      if (findEventIndex(mergedEvents, event) === -1) {
        mergedEvents.push(event);
      }
    });
  }
  
  // 5. Store merged events in both localStorage and sessionStorage
  if (mergedEvents.length > 0) {
    console.log(`Storing ${mergedEvents.length} merged events to storage`);
    const eventsJson = JSON.stringify(mergedEvents);
    localStorage.setItem('marketEvents', eventsJson);
    sessionStorage.setItem('marketEvents', eventsJson);
    
    // Also make it available globally
    window.allEvents = mergedEvents;
    
    // Dispatch an event to notify the calendar that events have been loaded
    document.dispatchEvent(new CustomEvent('marketEventsLoaded', {
      detail: { events: mergedEvents, source: 'firestore' }
    }));
  } else {
    console.log("No events found in any source");
  }
  
  // 6. Try to update Firestore if we have write access
  if (mergedEvents.length > 0 && firestoreEvents.length === 0 && window.db) {
    try {
      console.log("Attempting to update Firestore with merged events...");
      
      // Try writing a sample event to test permissions
      const testEvent = mergedEvents[0];
      const testId = testEvent.id || `event-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
      
      window.db.collection('events').doc(testId).set(testEvent)
        .then(() => {
          console.log("Successfully wrote to Firestore, syncing all events...");
          
          // If successful, sync all events
          const batch = window.db.batch();
          
          mergedEvents.forEach(event => {
            const eventId = event.id || `event-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
            const docRef = window.db.collection('events').doc(eventId);
            batch.set(docRef, event);
          });
          
          return batch.commit();
        })
        .then(() => {
          console.log("All events successfully synchronized to Firestore");
        })
        .catch(error => {
          console.error("Error writing to Firestore:", error);
          console.log("Will continue to use localStorage/sessionStorage for events");
        });
    } catch (error) {
      console.error("Error syncing to Firestore:", error);
    }
  }
}

// Add a manual refresh button to the page if on the events calendar
setTimeout(function() {
  const calendarContainer = document.querySelector('.market-events-calendar');
  const filterContainer = document.querySelector('.market-events-filters');
  
  if (calendarContainer && filterContainer) {
    const refreshButton = document.createElement('button');
    refreshButton.className = 'market-events-refresh-button';
    refreshButton.textContent = 'Refresh Events';
    refreshButton.style.marginLeft = '15px';
    refreshButton.style.padding = '0.5rem 1rem';
    refreshButton.style.backgroundColor = 'var(--color-button-background, #2c6ecb)';
    refreshButton.style.color = 'var(--color-button-text, white)';
    refreshButton.style.border = 'none';
    refreshButton.style.borderRadius = '4px';
    refreshButton.style.cursor = 'pointer';
    
    refreshButton.addEventListener('click', function() {
      syncEvents().then(() => {
        // Reload the page to refresh the calendar
        window.location.reload();
      });
    });
    
    filterContainer.appendChild(refreshButton);
  }
}, 2000);

// Listen for the DOMContentLoaded event on all pages
document.addEventListener('marketEventsLoaded', function(e) {
  console.log('Market events loaded event received:', e.detail.events.length);
  
  // Trigger any necessary updates on the page
  if (typeof window.generateCalendar === 'function') {
    window.generateCalendar();
  }
  
  if (typeof window.updateEventVisibility === 'function') {
    window.updateEventVisibility();
  }
}); 